import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useCallback, useContext, useMemo } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { NativeModalId } from '~/context/vdp/ModalContext/constants';
import { logError } from '~/utilities/loggers';
import { ListenerEvent, type ListenerEventType } from './constants';

type CloseModalPayload = { modal: NativeModalId };

function isCloseModalMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, CloseModalPayload> {
  return (
    message.event === ListenerEvent.CloseModal && message.payload.modal != null
  );
}

function useHandleCloseModal(): (modal: NativeModalId) => void {
  const {
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setSoftPullModalOpen
  } = useContext(ModalContext);

  return useCallback(
    (modal: NativeModalId) => {
      switch (modal) {
        case NativeModalId.SoftPull:
          setAddCoApplicantModalOpen(false);
          setEditCoApplicantModalOpen(false);
          setSoftPullModalOpen(false);
          break;
        default:
          logError(new Error('Unknown modal'), { modal });
      }
    },
    [
      setAddCoApplicantModalOpen,
      setEditCoApplicantModalOpen,
      setSoftPullModalOpen
    ]
  );
}

export default function useCloseModalHandler(): MessageHandler<
  ListenerEventType,
  CloseModalPayload
> {
  const handleCloseModal = useHandleCloseModal();

  return useMemo(
    () =>
      new MessageHandler(isCloseModalMessage, message => {
        handleCloseModal(message.payload.modal);
      }),
    [handleCloseModal]
  );
}
